import { useEffect, useState } from "react";

// Typewriter that cycles through words
export default function TypeRotator({ words, speed = 45, pause = 1800 }) {
  const [i, setI] = useState(0);
  const [len, setLen] = useState(0);
  const [del, setDel] = useState(false);

  useEffect(() => {
    const word = words[i];
    let t;
    if (!del && len < word.length) t = setTimeout(() => setLen(len + 1), speed);
    else if (!del) t = setTimeout(() => setDel(true), pause);
    else if (len > 0) t = setTimeout(() => setLen(len - 1), speed / 2);
    else {
      setDel(false);
      setI((i + 1) % words.length);
    }
    return () => clearTimeout(t);
  }, [len, del, i, words, speed, pause]);

  return <span className="caret">{words[i].slice(0, len)}</span>;
}
